import { render, staticRenderFns } from "./IndividualApprovalsList.vue?vue&type=template&id=3ad369b2&scoped=true"
import script from "./IndividualApprovalsList.vue?vue&type=script&lang=js"
export * from "./IndividualApprovalsList.vue?vue&type=script&lang=js"
import style0 from "./IndividualApprovalsList.vue?vue&type=style&index=0&id=3ad369b2&prod&scoped=true&lang=css"
import style1 from "./IndividualApprovalsList.vue?vue&type=style&index=1&id=3ad369b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad369b2",
  null
  
)

export default component.exports